import type { VehicleType } from '@breaker/shared-types';

/**
 * One label map for the WHOLE vehicle_type ladder (0002 originals + the 0026
 * HBC/CX size ladder + 0044). The vehicles page's 0002-era map and the
 * settings rate-card map both predate the full ladder — new code reads from
 * here so the three surfaces can't drift.
 */
export const VEHICLE_TYPE_LABELS: Record<VehicleType, string> = {
  cycle: 'Cycle',
  cargo_bike: 'Cargo bike',
  motorcycle: 'Motorcycle',
  car: 'Car',
  small_van: 'Small van',
  midi_van: 'Midi van',
  swb: 'SWB van',
  mwb: 'MWB van',
  lwb: 'LWB van',
  xlwb: 'XLWB van',
  luton: 'Luton',
  jumbo_luton: 'Jumbo Luton',
  van: 'Van',
  rigid_7_5t: '7.5t rigid',
  rigid_12t: '12t rigid',
  rigid_18t: '18t rigid',
  rigid_26t: '26t rigid',
  artic: 'Artic',
  drawbar: 'Drawbar',
  flatbed: 'Flatbed',
  curtainsider: 'Curtainsider',
  box: 'Box',
  refrigerated: 'Refrigerated',
  tipper: 'Tipper',
  skellie_1x20: 'Skellie 1×20',
  skellie_2x20: 'Skellie 2×20',
  skellie_1x40: 'Skellie 1×40',
  skellie_1x44: 'Skellie 1×44',
  tractor_4axle: 'Tractor unit (4-axle)',
  tractor_6axle: 'Tractor unit (6-axle)',
  other: 'Other',
};

export function vehicleTypeLabel(type: VehicleType | string | null | undefined): string {
  if (!type) return '—';
  return VEHICLE_TYPE_LABELS[type as VehicleType] ?? String(type).replace(/_/g, ' ');
}

/** The bookable size ladder, smallest first — the order pickers present. */
export const VEHICLE_LADDER_ORDER: VehicleType[] = [
  'cycle',
  'cargo_bike',
  'motorcycle',
  'car',
  'small_van',
  'midi_van',
  'swb',
  'mwb',
  'lwb',
  'xlwb',
  'luton',
  'jumbo_luton',
  'van',
  'rigid_7_5t',
  'rigid_12t',
  'rigid_18t',
  'rigid_26t',
  'artic',
  'drawbar',
  'flatbed',
  'curtainsider',
  'box',
  'refrigerated',
  'tipper',
  'skellie_1x20',
  'skellie_2x20',
  'skellie_1x40',
  'skellie_1x44',
  'tractor_4axle',
  'tractor_6axle',
  'other',
];
